/**
 * Global top bar — a thin strip at the top of every authenticated page (in the page flow, so it never covers content).
 * Home → /admin/dashboard · active site badge · Request Vehicle (hidden inside Transport / My Pay).
 * Mounted once from <ProtectedRoute>.
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, MapPin, Truck } from 'lucide-react';

const SITE_LABEL_FALLBACK = {
  salem: 'Salem',
  srivilliputhur: 'Srivilliputhur',
  chennai: 'Chennai',
};
const HIDE_VEHICLE_PREFIXES = ['/sections/transport', '/attendance/kiosk', '/my-pay'];

export default function GlobalNavOverlay() {
  const navigate = useNavigate();
  const path = useLocation().pathname || '';

  const siteId = (typeof window !== 'undefined' && localStorage.getItem('active_site_id')) || 'salem';
  const siteName =
    (typeof window !== 'undefined' && localStorage.getItem('active_site_name')) ||
    SITE_LABEL_FALLBACK[siteId] ||
    'Salem';
  const showVehicle = !HIDE_VEHICLE_PREFIXES.some((p) => path === p || path.startsWith(p + '/'));

  return (
    <div
      data-testid="global-nav-overlay"
      className="relative z-[60] h-8 w-full flex items-center justify-between gap-2 bg-stone-900 text-white px-2 sm:px-4 text-xs print:hidden"
    >
      <div className="flex items-center gap-1.5 min-w-0">
        <button
          type="button"
          onClick={() => navigate('/admin/dashboard')}
          data-testid="global-nav-home-btn"
          title="Go to Dashboard"
          className="flex items-center gap-1.5 rounded-full px-2.5 py-0.5 font-medium hover:bg-white/15 active:bg-white/25 transition-colors"
        >
          <Home className="h-3.5 w-3.5" />
          <span>Home</span>
        </button>
        <div className="h-4 w-px bg-white/15" />
        <div
          data-testid="global-nav-site-badge"
          className="flex items-center gap-1 rounded-full bg-emerald-600/90 px-2.5 py-0.5 font-semibold truncate"
          title={`Active site: ${siteName}`}
        >
          <MapPin className="h-3.5 w-3.5 shrink-0" />
          <span data-testid="global-nav-site-name" className="truncate">{siteName}</span>
        </div>
      </div>
      {showVehicle && (
        <button
          type="button"
          onClick={() => navigate('/sections/transport/request-vehicle')}
          data-testid="global-request-vehicle-fab"
          title="Request a Vehicle"
          className="flex items-center gap-1.5 rounded-full bg-amber-500 hover:bg-amber-400 active:scale-95 text-[#1A1F2E] font-semibold px-2.5 py-0.5 transition-colors shrink-0"
        >
          <Truck className="h-3.5 w-3.5" />
          <span>Request Vehicle</span>
        </button>
      )}
    </div>
  );
}
